import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    trip: Yup.object({
      travelerId: Yup.string().required('Required').nullable(),
    }),
    tripItems: Yup.array().of(
      Yup.object().shape({
        departureDate: Yup.date().nullable(),
        departureArrivalDate: Yup.date()
          .min(
            Yup.ref('departureDate'),
            'Arrival date must be greater than departure'
          )
          .nullable(),
        returnDate: Yup.date()
          .min(
            Yup.ref('departureDate'),
            'Return date must be greater than departure'
          )
          .nullable(),
        returnArrivalDate: Yup.date()
          .min(
            Yup.ref('returnDate'),
            'Arrival date must be greater than departure'
          )
          .nullable(),
        departureTime: Yup.string().nullable(),
        departureArrivalTime: Yup.string().nullable(),
        checkInDate: Yup.date().nullable(),
        checkOutDate: Yup.date()
          .min(
            Yup.ref('checkInDate'),
            'Drop off date must be greater than Pickup'
          )
          .nullable(),
      })
    ),
  });
